import store from 'redux/store';
import { ActivityKey } from 'redux/schemas/models/activity';
import { setActivityProgress } from 'redux/actions/lecture-components';

/* @ngInject */
export default function TimelinePublicFeedbackCriteriaLectureComponentModelService(
  _,
  moment,
  nvUtil,
) {
  class TimelinePublicFeedbackCriteriaLectureComponent {
    constructor(attributes) {
      const base = {
        templateUrl: 'timelines/templates/nv-timeline-video-practice-feedback.html',
      };

      /** Setting Up Basic Attributes * */
      _.extend(this, base, attributes);
      // passed lecturePage, lectureSection, course
      this.preprocess();
    }

    /** Function Declarations * */
    /* Used Publicly */
    getStatus() {
      return this.publicFeedback.progress;
    }

    isCompleted() {
      return this.publicFeedback.progress === 'completed';
    }

    isMissed() {
      return this.publicFeedback.progress === 'missed';
    }


    isTodoRequiredForCompletion() {
      return this.publicFeedback.isRequiredForCompletion;
    }

    isPrereqCompleted(prereq) {
      if (prereq.type === 'FeedbackCriteria' && prereq.id === this.publicFeedback.id) {
        return this.isCompleted();
      }
      return false;
    }

    updateComponentPointsAndProgress(componentType, componentId, pointsReceived, totalPoints, progress) {
      if ((this.type === componentType && this.id === componentId)
        || (componentType === 'feedback_criteria' && this.publicFeedback.id === componentId)
      ) {
        this.publicFeedback.progress = progress ?? 'completed';

        store.dispatch(setActivityProgress({
          pointsReceived,
          progress: this.publicFeedback.progress,
          activityKey: ActivityKey.VIDEO_PRACTICE_FEEDBACK,
          activityPayloadId: this.publicFeedback.id,
        }));

        this.publicFeedback.pointsReceived = pointsReceived;
        this.pointsReceived = pointsReceived;

        if (_.isNumber(totalPoints)) {
          this.currentTotalPoints = totalPoints;
        } else {
          this.currentTotalPoints = nvUtil.getCurrentTotalPoints(this.totalPoints, this.lecturePage.releaseDate, this.course.expiringPointsEnabled);
        }

        this.viewPreprocess();

        this.lecturePage.preprocessSelfAndParentPointData();
      }
    }

    updateComponentProgress(componentType, componentId, progress) {
      if ((this.type === componentType && this.id === componentId) || (componentType === 'feedback_criteria' && this.publicFeedback.id === componentId)) {
        this.publicFeedback.progress = progress;
        store.dispatch(setActivityProgress({
          progress,
          activityKey: ActivityKey.VIDEO_PRACTICE_FEEDBACK,
          activityPayloadId: this.publicFeedback.id,
        }));
        this.lecturePage.preprocessSelfAndParentPointData();
      }
    }

    getPayload() {
      return _.pick(this, ['title', 'deadline', 'hardDeadline']);
    }

    hasDeadline() {
      return !!this.publicFeedback.deadline;
    }

    setDeadline(newDeadline) {
      this.publicFeedback.deadline = newDeadline;
      this.deadline = newDeadline;
    }

    isDeadlineBeforeLesson() {
      return this.publicFeedback.deadline < this.lecturePage.releaseDate;
    }

    /* Used Privately */
    preprocess() {
      this.title = this.publicFeedback.title;
      this.deadline = this.publicFeedback.deadline;
      this.isTodo = this.publicFeedback.isTodo;
      this.hasStructuralIssues = this.publicFeedback.hasStructuralIssues;
      this.pointsReceived = this.publicFeedback.pointsReceived;
      this.totalPoints = this.publicFeedback.totalPoints;
      this.activityId = this.publicFeedback.id;

      this.currentTotalPoints = nvUtil.getCurrentTotalPoints(this.totalPoints, this.lecturePage.releaseDate, this.course.expiringPointsEnabled);

      this.viewPreprocess();
    }

    viewPreprocess() {
      this.showDueSoon = this.__showDueSoon();

      if (this.isCompleted() || this.pointsReceived > this.currentTotalPoints) {
        this.currentTotalPoints = this.pointsReceived ? this.pointsReceived : 0;
      }
      this.displayTotalPointsOnly = !this.pointsReceived && this.currentTotalPoints;
    }

    __showDueSoon() {
      if (this.publicFeedback.deadline) {
        return !this.isCompleted() && moment(this.publicFeedback.deadline) > moment() && moment(this.publicFeedback.deadline) < moment().add(7, 'days');
      }
      return false;
    }
  }

  return TimelinePublicFeedbackCriteriaLectureComponent;
}
